<div class="validate-token-container text-center">
  <img src="../../../assets/dynamic-icons/camion.gif" alt="loading-truck" class="gif-color-change">
  <h2>¡Bienvenido a Loggiapp!</h2>
  <p>Estamos verificando tu acceso. Esto solo tomará unos segundos...</p>
</div>
